export const calibrationConstants = {
  cardHeightMm: 53.98,
  cardWidthMm: 85.6,
  circleDimensionsReferenceMm: 4,
  tangent15degrees: 0.26794919243,
  imageWidthReference: 300,
  patientDistanceReference: 500,
  clientYmmArchDegree: 0.1,
  blindSpotThumbnailWidthPx: 220,
  blindSpotThumbnailHeightPx: 154,
  blindSpotThumbnailY: 250,
  pixelDensityReference: 0.31,
  perceivedFocalLength: 909,
  averageAdultHumanFaceWidthMm: 165,
  averagePupillaryDistanceMm: 65,
  VIDEO_BORDER_RADIUS: 10,
};

export const ibisTool = {
  selectValue: 'ibisV2',
  calibrationTriangleWidthInMm: 5,
  calibrationTriangleWidthInPx: 37,
  distanceCalibrationTriangleInMm: 130,
  distanceFrontTrianglesInMm: 38,
  thresholdMinimumSizePixels: 150,
  thresholdMaximumSizePixels: 500,
  thresholdMaximumIntervalPixels: 30,
  minimumValidCollections: 3,
  waitingTimeBetweenCollections: 1000,
  distanceThresholdMinimumSizePixels: 50,
  distanceThresholdMaximumSizePixels: 500,
  distanceThresholdMaximumIntervalPixels: 100,
};
